/**
 *  builds search params for crm view, merging with existing params
 */

type CRMNavLevel =
  | { level: "org" }
  | { level: "group"; groupId: number }
  | { level: "location"; groupId: number | string; locationId: number | string };

export function buildCRMSearchParams(nav: CRMNavLevel, existing?: URLSearchParams): string {
  const params = new URLSearchParams(existing);

  // remove crm-specific navigation params
  params.delete("groupId");
  params.delete("locationId");
  params.delete("viewAll");

  switch (nav.level) {
    case "org":
      params.set("viewAll", "true");
      break;
    case "group":
      params.set("groupId", String(nav.groupId));
      break;
    case "location":
      params.set("groupId", String(nav.groupId));
      params.set("locationId", String(nav.locationId));
      break;
  }

  return `?${params.toString()}`;
}

/**
 * parses a string with optional "none" value into a number or undefined
 */
export function parseOptionalNumber(value: string | null): number | undefined {
  if (!value || value === "none") {
    return undefined;
  }

  const parsedValue = Number(value);
  return isNaN(parsedValue) ? undefined : parsedValue;
}
